import { ModalCloseBtn, ModalHeader, ModalTitle } from "../styled/Modal.style";
import 'reactjs-popup/dist/index.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import linearClose from '../../assets/img/linear_close_gray.svg';

export interface ModalHeaderCmpProps {
    hTitle?: string;
    hCloseButton?: boolean;
    close?: any;
    companyName?: string;
}

export const ModalHeaderCmp = (props: ModalHeaderCmpProps) => {
    const { hTitle, hCloseButton, close, companyName } = props

    return (
        <>
            <ModalHeader className={companyName}>
                {hTitle && <ModalTitle className={companyName}>{hTitle}</ModalTitle>}
                {hCloseButton &&
                    <ModalCloseBtn
                        className={"modal-close-btn " + companyName}
                        onClick={close}>
                        {companyName === "LINEAR" ? <img
                            src={linearClose}
                            alt="TrashBin"
                            style={{ width: "25px", marginRight: "10px" }}
                        /> : <FontAwesomeIcon icon={faTimes} />}
                    </ModalCloseBtn>
                }
            </ModalHeader>
        </>
    )
}
